export class ApplicationError {
  constructor(
    public message: string,
    public stackTrace: any[],
    public createdOn: string,
    public severityType: string = 'Error'
  ) { }
}
